import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { GlobalDataContext } from "../../../contexts/GlobalData";
import { PET_BIOMETRICS } from "../../../enums/ApiPaths";
import { EDIT_APPOINTMENT } from "../../../enums/PermissionTitles";
import { PET_BIOMETRICS_DATA } from "../../../enums/QueryKeys";
import DialogCore from "../../saps/components/core/DialogCore";
import BiometricsForm from "./BiometricsForm";

const formId = "add_pet_biometrics_form";

export default function AddBiometricsDialog({ petId }) {
  const { t } = useTranslation();
  const methods = useForm();
  const [savedCount, setSavedCount] = React.useState(0);
  const { isPermissionAllowed } = React.useContext(GlobalDataContext);

  return (
    <DialogCore
      formId={formId}
      disabled={!isPermissionAllowed(EDIT_APPOINTMENT)}
      fontWeight={800}
      buttonTitle={t("AddBiometrics")}
      maxWidth="md"
      title={t("AddBiometrics")}
      closeWhen={savedCount}
    >
      <FormProvider {...methods}>
        <BiometricsForm
          queryKey={PET_BIOMETRICS_DATA + petId}
          apiKey={PET_BIOMETRICS}
          id={petId}
          formId={formId}
          onSuccess={() => setSavedCount((count) => count + 1)}
        />
      </FormProvider>
    </DialogCore>
  );
}
